<!--SKU编辑  -->
<template>
	<div class="dialogBox">
		<el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false"
			:modal-append-to-body="false" width="800px">
			<div class="form-box">
				<div class="flex mt5">
					<el-input v-model.trim="userName" class="w190" size="small" placeholder="用户名" maxlength="16"
						clearable>
					</el-input>
					<img class="icon-img ml10" src="@/assets/images/search.png" @click="getList" alt="">
				</div>
				<div v-if="tableData.length>0">
					<el-table :data="tableData"
						:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}" class="mt15"
						@selection-change="handleSelectionChange" border style="width: 100%" max-height="450">
						<el-table-column type="selection" width="50" align="center">
						</el-table-column>
						<el-table-column v-show="tableData" v-for="(value, index) in titles" :key="index"
							:show-overflow-tooltip="true" :label="value.title" :min-width="value.maxWidth">
							<template slot-scope="scope">
								{{scope.row.datas[index]}}
							</template>
						</el-table-column>
					</el-table>
				</div>
				<el-empty v-else description="暂无数据"></el-empty>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				dialogVisible: false,
				userName: "",
				pageNo: 1,
				pageSize: 20,
				tableData: [],
				titles: [],
				multipleSelection: [],
			}
		},
		created() {

		},
		methods: {
			init(data) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.titles = []
					this.tableData = []
					this.selectValue = data
					this.pageNo = 1;
					this.userName = '';
					this.multipleSelection=[]
					this.getList()
				})
			},
			// 获取用户列表
			getList() {
				let that = this;
				that.$request.post(
						"groupUserListPage",
						true, {
							pageNo: that.pageNo,
							pageSize: that.pageSize,
							userName: that.userName,
							neGroupId: that.selectValue.groupId
						}
					)
					.then((res) => {
						if (res.data && res) {
							that.titles = res.data.titles
							that.tableData = res.data.tableDatas
						} else {
							that.titles = []
							that.tableData = []
						}
					})
			},
			// 列多选
			handleSelectionChange(val) {
				console.log(val)
				this.multipleSelection = val;
			},
			// 保存
			submitForm() {
				if (this.multipleSelection.length <= 0) {
					this.$message.error('请先选择用户!');
					return
				}
				this.$confirm('是否确认保存？', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
				}).then(() => {
				this.addRow()
				}).catch(() => {});
			},
			// 新增
			addRow() {
				let that = this;
				let userIds = []
				that.multipleSelection.forEach(item => {
					userIds.push(item.dataKey)
				});
				console.log(that.ruleForm)
				that.$request.post(
						"groupAddUser",
						true, {
							groupId: that.selectValue.groupId,
							userIds: userIds,
						}
					)
					.then((res) => {
						if (res) {
							that.dialogVisible = false
							that.$message.success("保存成功！");
							that.$emit("getList")
						}
					})
			},
			// 取消
			cancle() {
				this.dialogVisible = false
			}
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.dialogBox {
		/deep/ .el-dialog__header {
			background: #fff;
		}

		/deep/ .el-dialog__body {
			padding: 0px 20px;
		}

	}

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 5px;
		}

		/deep/ td {
			padding: 5px;
		}
	}

</style>
